import React from "react";
import {
  Box,
  Skeleton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

export const CategorySkeleton = () => {
  return (
    <Box
      sx={{
        flexDirection: "row",
        display: "flex",
        gap: "100px",
        overflowX: "auto",
        whiteSpace: "nowrap",
        width: "100%",
        paddingBottom: "10px",
        "&::-webkit-scrollbar": { display: "none" },
        justifyContent: "space-evenly",
      }}
    >
      {Array.from(new Array(5)).map((_, index) => (
        <Grid size={{ xs: 2, sm: 3, md: 3, lg: 2 }} key={index}>
          <Skeleton
            variant="circular"
            sx={{
              width: { xs: "75px", sm: "85px", md: "110px", lg: "160px" },
              height: { xs: "75px", sm: "85px", md: "110px", lg: "160px" },
            }}
          />
          {/* <Skeleton
            variant="text"
            width="100%"
            sx={{
              mt: 1,
              height: { xs: "20px", md: "30px" },
            }}
          /> */}
        </Grid>
      ))}
    </Box>
  );
};

export const RectangularSkeleton = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // <600px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600px–899px

  let skeletonCount = 3; // default for laptop and above
  if (isMobile) skeletonCount = 1;
  else if (isTablet) skeletonCount = 2;
  return (
    <>
      <Skeleton variant="text" width="20%" height={30} sx={{ mb: 2 }} />
      <Grid container spacing={3}>
        {Array.from(new Array(skeletonCount)).map((_, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
            <Skeleton
              variant="rectangular"
              width="100%"
              sx={{ borderRadius: 1, height: { xs: 150, sm: 200, md: 300 } }}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export const RectangularSkeleton2 = () => {
  return (
    <>
      <Skeleton variant="text" width="20%" height={30} sx={{ mb: 2 }} />
      <Box
        sx={{
          display: "flex",
          overflowX: "auto",
          gap: 3,
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {Array.from(new Array(4)).map((_, index) => (
          <Box
            key={index}
            sx={{ flex: "0 0 auto", width: { xs: 150, md: 200, lg: 300 } }}
          >
            <Skeleton
              variant="rectangular"
              width="100%"
              height={300}
              sx={{ borderRadius: 1 }}
            />
          </Box>
        ))}
      </Box>
    </>
  );
};
export const SquareSkeleton = () => {
  return (
    <>
      <Skeleton variant="text" width="20%" height={30} sx={{ mb: 2 }} />
      <Grid container spacing={8}>
        {Array.from(new Array(6)).map((_, index) => (
          <Grid size={{ xs: 6, sm: 4 }} key={index}>
            <Skeleton
              variant="rectangular"
              width="100%"
              sx={{ borderRadius: 1, height: { xs: 150, sm: 200, md: 300 } }}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export const OvalSkeleton = () => {
  return (
    <>
      <Skeleton variant="text" width="20%" height={30} sx={{ mb: 2 }} />
      <Grid container spacing={{ xs: 3, sm: 6, md: 8 }}>
        {Array.from(new Array(8)).map((_, index) => (
          <Grid size={{ xs: 6, sm: 4, md: 4, lg: 3 }} key={index}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <Skeleton
                variant="rectangular"
                sx={{
                  width: "100%",
                  aspectRatio: "1 / 1.2",
                  borderRadius: "50% / 40%",
                  transform: "none",
                }}
              />
              <Skeleton
                variant="text"
                width="80%"
                sx={{
                  height: { xs: "20px", md: "24px" },
                  borderRadius: "4px",
                }}
              />
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
};
